import { Tool } from "../models/Tool";

export const tools: Tool[] = [
    {
        id: 1,
        title: ["Profitability"],
        subTitle:
            "Analysis and benchmarking to provide a holistic view of net profitability across each business segment",
        features: [
            {
                id: 0,
                name: "Profitability Summary",
                url: "/customer-profitability",
            },
            {
                id: 1,
                name: "Profitability Waterfall",
                url: "/customer-profitability?active=breakDown",
            },
        ],
    },
    {
        id: 2,
        title: ["Pricing"],
        subTitle:
            "In-depth analysis and scenario simulations to support pricing",
        features: [{ id: 0, name: "Pricing", url: "/pricing" }],
    },
    {
        id: 3,
        title: ["Cost-to-Serve"],
        subTitle:
            "In-depth analysis and scenario simulations to identify levers to reduce cost-to-serve",
        features: [{ id: 0, name: "Cost-to-Serve", url: "/cts" }],
    },
    {
        id: 4,
        title: ["Strategic Growth"],
        subTitle: "Strategic areas by which to grow the business profitably ",
        features: [
            { id: 0, name: "White Label Pricing", url: "/wlp" },
            { id: 1, name: "Cross Sell", url: "/cross-sell" },
        ],
    },
];
